import { useState } from "react";
import { Button, Modal, Input, message } from "antd";
import { FaWhatsapp, FaTelegramPlane, FaCopy } from "react-icons/fa";
import { PiShareFatFill } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { GetCampaignRes } from "../api";
import { MyColor } from "../config/myStyle";
import config from "../config";
import "./ShareCampaign.css";

export default function ShareCampaign({ campaign, variant }: {
  campaign?: GetCampaignRes;
  variant: "record" | "result";
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const url = campaign ? `${config.REACT_APP_HOST.replace(/\/$/, "")}/donation/${campaign.id}` : "";
  const text = t("share_campaign.whatsapp_text", { title: campaign?.title || "", url });
  const shareData = { title: campaign?.title, text, url };
  const canShare = typeof navigator.share === "function" &&
    (typeof navigator.canShare !== "function" || navigator.canShare(shareData));
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      message.success(t("sharing.copied"));
    } catch { message.info(t("sharing.manual_copy")); }
  };
  const nativeShare = async () => {
    try { await navigator.share(shareData); }
    catch (error: any) {
      if (error.name !== "AbortError") message.info(t("sharing.manual_copy"));
    }
  };
  return <>
    {/* 只供原有兩個入口使用，完整保留各頁既有按鈕尺寸、顏色及圖示。 */}
    <Button type="primary" disabled={!campaign} onClick={() => setOpen(true)}
      className={variant === "record" ? "w-[180px] flex mb-[10px] mt-[14px] rounded-full" : "flex-1"}
      style={variant === "record" ? {
        background: MyColor.red, border: "none", fontSize: 18, height: 46,
        fontWeight: 600, boxShadow: "0 2px 8px #eecbe0", justifySelf: "center",
      } : {
        background: "#bfa373", color: "#fff", border: "none", borderRadius: 28,
        fontWeight: 500, fontSize: 21, height: 50,
      }}>
      {variant === "record" && <PiShareFatFill className="text-[32px]" />}
      {t(variant === "record" ? "my_record_detail.share" : "donation_result.share")}
    </Button>
    {/* 擴充選項沿用網站的藍色框線、米白底及圓角，沒有新增頁面入口。 */}
    <Modal className="fa-share-dialog" open={open} title={t("my_record_detail.share")}
      onCancel={() => setOpen(false)} footer={null} width={480} centered>
      <div className="fa-share-options">
        <Button className="fa-share-option" icon={<FaWhatsapp />} href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer">WhatsApp</Button>
        <Button className="fa-share-option" icon={<FaTelegramPlane />} href={`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(campaign?.title || "")}`} target="_blank" rel="noopener noreferrer">Telegram</Button>
        {canShare && <Button className="fa-share-option" icon={<PiShareFatFill />} onClick={nativeShare}>{t("sharing.more")}</Button>}
        <Button className="fa-share-option" icon={<FaCopy />} onClick={copy}>{t("sharing.copy")}</Button>
      </div>
      <Input className="fa-share-link" aria-label={t("sharing.link")} readOnly value={url} onFocus={event => event.target.select()} />
      <p className="fa-share-hint">{t("sharing.hint")}</p>
    </Modal>
  </>;
}
